import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSwitch.css';

export default function LanguageSwitch() {
  const langContext = useLanguage();

  const currentLanguage =
    langContext.language || langContext.lang || 'es';

  const handleChange = (value) => {
    if (typeof langContext.setLanguage === 'function') {
      langContext.setLanguage(value);
      return;
    }

    if (typeof langContext.setLang === 'function') {
      langContext.setLang(value);
      return;
    }

    if (typeof langContext.changeLanguage === 'function') {
      langContext.changeLanguage(value);
      return;
    }

    console.error('No se encontró función para cambiar idioma en LanguageContext');
  };

  return (
    <div className="language-switch" aria-label="Selector de idioma">
      <button
        type="button"
        className={currentLanguage === 'es' ? 'active' : ''}
        onClick={() => handleChange('es')}
      >
        ES
      </button>

      <button
        type="button"
        className={currentLanguage === 'en' ? 'active' : ''}
        onClick={() => handleChange('en')}
      >
        EN
      </button>
    </div>
  );
}